import { render } from "./LearningChart.vue?vue&type=template&id=a1bf29d4"
import script from "./LearningChart.vue?vue&type=script&lang=js"
export * from "./LearningChart.vue?vue&type=script&lang=js"

import "./LearningChart.vue?vue&type=style&index=0&id=a1bf29d4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__